import { FC, ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface InfoRowProps {
  icon: LucideIcon;
  label: string;
  value: ReactNode;
  iconClassName?: string;
}

export const InfoRow: FC<InfoRowProps> = ({
  icon: Icon,
  label,
  value,
  iconClassName = 'text-neutral-500',
}) => {
  return (
    <div className="flex items-center gap-3 text-sm">
      <Icon className={`w-5 h-5 ${iconClassName}`} />
      <div>
        <div className="font-medium text-neutral-900">{label}</div>
        <div className="text-neutral-600">{value}</div>
      </div>
    </div>
  );
};
